import { getLineasFinancieras } from './getLineasFinancieras'

export const Simulador = {
  getLineasFinancieras
}
